// This value is updated during the Azure DevOps pipeline build to bust the cache.
app.constant("VERSION", "1793778437224");

app.constant("AUTH_EVENTS", {
	loginSuccess: "auth-login-success",
	loginFailed: "auth-login-failed",
	logoutSuccess: "auth-logout-success",
	sessionTimeout: "auth-session-timeout",
	notAuthenticated: "auth-not-authenticated",
	notAuthorized: "auth-not-authorized",
});

// The $rootScope broadcast names PushEventService publishes, one per backend PushEventType, plus
// ANY for the catch-all. These must stay in step with the PushEventType enum in CatTraxCore - an
// event type with no entry here is still broadcast as "pushEvent:<TYPE>", it just has no constant.
//
//   $scope.$on(PUSH_EVENTS.INVOICE_PAID, function (e, event) { ... event.data.invoiceId ... });
//
// The event only names what changed; the listener re-fetches the detail.
app.constant("PUSH_EVENTS", {
	ANY: "pushEvent",
	INVOICE_ADDED: "pushEvent:INVOICE_ADDED",
	INVOICE_UPDATED: "pushEvent:INVOICE_UPDATED",
	INVOICE_DELETED: "pushEvent:INVOICE_DELETED",
	INVOICE_PAID: "pushEvent:INVOICE_PAID",
	// A Tyro transaction recorded, changed or deleted - a claim, an eligibility quote, a patient invoice or
	// a patient payment - from a user's request, a Tyro webhook or the processing report sweep. Published
	// after the row is saved, so a re-fetch on one reads the row as it now stands.
	// { transactionId, patientId, transactionType, status, invoiceId? }
	CLAIM_ADDED: "pushEvent:CLAIM_ADDED",
	CLAIM_UPDATED: "pushEvent:CLAIM_UPDATED",
	CLAIM_DELETED: "pushEvent:CLAIM_DELETED",
	APPOINTMENT_ADDED: "pushEvent:APPOINTMENT_ADDED",
	APPOINTMENT_UPDATED: "pushEvent:APPOINTMENT_UPDATED",
	APPOINTMENT_DELETED: "pushEvent:APPOINTMENT_DELETED",
	CALENDAR_AVAILABILITY_ADDED: "pushEvent:CALENDAR_AVAILABILITY_ADDED",
	CALENDAR_AVAILABILITY_UPDATED: "pushEvent:CALENDAR_AVAILABILITY_UPDATED",
	CALENDAR_AVAILABILITY_DELETED: "pushEvent:CALENDAR_AVAILABILITY_DELETED",
	TASK_ADDED: "pushEvent:TASK_ADDED",
	TASK_UPDATED: "pushEvent:TASK_UPDATED",
	TASK_DELETED: "pushEvent:TASK_DELETED",
	SURGERY_WAITLIST_ADDED: "pushEvent:SURGERY_WAITLIST_ADDED",
	SURGERY_WAITLIST_UPDATED: "pushEvent:SURGERY_WAITLIST_UPDATED",
	PRACTICE_UPDATED: "pushEvent:PRACTICE_UPDATED",
	// A patient's own details - name, contacts, address, identifiers, insurance, next of kin - edited
	// by another user. Only ever an update to an existing patient, never a registration.
	// { patientId, updatedByUserId }. updatedByUserId is what tells another user's edit from the echo
	// of your own: both arrive on the same practice channel.
	PATIENT_UPDATED: "pushEvent:PATIENT_UPDATED",
	// A patient moved to a different practice. Sent to the practice they left, whose users can no
	// longer open the record, and not to the one receiving them.
	// { patientId, fromPracticeId, toPracticeId, toPracticeName, transferredByUserId }
	PATIENT_TRANSFERRED_OUT: "pushEvent:PATIENT_TRANSFERRED_OUT",
	PATIENT_VERIFICATION_COMPLETED: "pushEvent:PATIENT_VERIFICATION_COMPLETED",
	VISION_ADDED: "pushEvent:VISION_ADDED",
	VISION_DELETED: "pushEvent:VISION_DELETED",
	PROGRESS_NOTE_ADDED: "pushEvent:PROGRESS_NOTE_ADDED",
	PROGRESS_NOTE_UPDATED: "pushEvent:PROGRESS_NOTE_UPDATED",
	PROGRESS_NOTE_DELETED: "pushEvent:PROGRESS_NOTE_DELETED",
	MEDICATION_ADDED: "pushEvent:MEDICATION_ADDED",
	MEDICATION_UPDATED: "pushEvent:MEDICATION_UPDATED",
	MEDICATION_DELETED: "pushEvent:MEDICATION_DELETED",
	ALLERGY_ADDED: "pushEvent:ALLERGY_ADDED",
	ALLERGY_UPDATED: "pushEvent:ALLERGY_UPDATED",
	ALLERGY_DELETED: "pushEvent:ALLERGY_DELETED",
	DIAGNOSIS_ADDED: "pushEvent:DIAGNOSIS_ADDED",
	DIAGNOSIS_UPDATED: "pushEvent:DIAGNOSIS_UPDATED",
	DIAGNOSIS_DELETED: "pushEvent:DIAGNOSIS_DELETED",
	PATIENT_FILE_ADDED: "pushEvent:PATIENT_FILE_ADDED",
	PATIENT_FILE_UPDATED: "pushEvent:PATIENT_FILE_UPDATED",
	PATIENT_FILE_DELETED: "pushEvent:PATIENT_FILE_DELETED",
	// Generated documents (notes, letters, forms rendered to PDF). Every document type the dashboard
	// lists publishes ADDED once its record is saved, and UPDATED when its PDF is regenerated in
	// place (a comment added to a note, an agreement signed). Nothing publishes DELETED yet.
	DOCUMENT_ADDED: "pushEvent:DOCUMENT_ADDED",
	DOCUMENT_UPDATED: "pushEvent:DOCUMENT_UPDATED",
	DOCUMENT_DELETED: "pushEvent:DOCUMENT_DELETED",
	// Any change to the care team - added by a user or automatically, activated, deactivated.
	// { patientCareTeamMemberId, patientId, memberType, status }
	CARE_TEAM_UPDATED: "pushEvent:CARE_TEAM_UPDATED",
	// A biometry scan removed from the record. { biometryScanId, patientId, patientFileId }
	BIOMETRY_DELETED: "pushEvent:BIOMETRY_DELETED",
	// Practice inventory, sent to the practice whose stock changed. Each carries
	// { itemId, variationId, updatedByUserId }; variationId is null for ADDED, ARCHIVED and RESTORED,
	// which are about the whole item. A move between practices sends STOCK_UPDATED to each, about its
	// own side.
	INVENTORY_ITEM_ADDED: "pushEvent:INVENTORY_ITEM_ADDED",
	// A variation's settings - minimum, barcode, location, units per pack - not its stock; or the
	// variation archived or restored.
	INVENTORY_ITEM_UPDATED: "pushEvent:INVENTORY_ITEM_UPDATED",
	INVENTORY_ITEM_ARCHIVED: "pushEvent:INVENTORY_ITEM_ARCHIVED",
	INVENTORY_ITEM_RESTORED: "pushEvent:INVENTORY_ITEM_RESTORED",
	// A variation's quantity, which can also move it on or off the reorder list.
	INVENTORY_STOCK_UPDATED: "pushEvent:INVENTORY_STOCK_UPDATED",
	// Published by Lambdas rather than the API, when work that finished outside a request lands.
	// The payload each carries is what the listener needs to act without a full reload:
	//   PATIENT_FILE_ANALYSED         { fileId, patientId, fileType } - the analyser finished with an
	//                                 uploaded file; fileType is what it decided, AI_ANALYSIS_FAILED
	//                                 when it could not.
	//   REFERRAL_ADDED                { referralId, patientId, fileId? } - a referral now exists for the
	//                                 patient; fileId is present when it was created from an upload.
	//   BIOMETRY_ADDED                { biometryScanId, patientId, patientFileId } - the analyser read a
	//                                 biometry scan out of an uploaded file and stored it.
	//   TRANSCRIPTION_COMPLETED       { transcriptionId, practiceId, patientId, status }
	//   TRANSCRIPTION_FAILED          { transcriptionId, practiceId, patientId, status }
	//   PROGRESS_NOTE_SNOMED_EXTRACTED { sourceType, sourceId, patientId } - extracted concepts were
	//                                 written back onto a PROGRESS_NOTE or a PATIENT_AI_CONVERSATION;
	//                                 sourceType says which list to re-read. Any diagnoses and
	//                                 allergies the extraction created arrive as their own ADDED events.
	PATIENT_FILE_ANALYSED: "pushEvent:PATIENT_FILE_ANALYSED",
	REFERRAL_ADDED: "pushEvent:REFERRAL_ADDED",
	BIOMETRY_ADDED: "pushEvent:BIOMETRY_ADDED",
	TRANSCRIPTION_COMPLETED: "pushEvent:TRANSCRIPTION_COMPLETED",
	TRANSCRIPTION_FAILED: "pushEvent:TRANSCRIPTION_FAILED",
	PROGRESS_NOTE_SNOMED_EXTRACTED: "pushEvent:PROGRESS_NOTE_SNOMED_EXTRACTED",
	// A custom form export the exporter Lambda finished rendering is ready to download.
	// { downloadUrl, ... }
	CUSTOM_FORM_EXPORT_READY: "pushEvent:CUSTOM_FORM_EXPORT_READY",
});

app.constant("USER_ROLES", {
	all: "*",
	admin: "admin",
	editor: "editor",
	guest: "guest",
});

// How old the CPAC impact-on-life answers on a referral may be before they stop counting.
// A referral that was started but never completed is resumed rather than replaced, so its
// answers can predate today's clinical exam; past this age they no longer describe the
// patient and a fresh set has to be answered before the referral can be scored publicly.
app.constant("IMPACT_ON_LIFE_VALID_MONTHS", 6);

// Used in the examination form to populate value in a select for both the left and right eyes
app.constant("LETTER", [
	{
		name: "+3",
		value: 3,
	},
	{
		name: "+2",
		value: 2,
	},
	{
		name: "+1",
		value: 1,
	},
	{
		name: "0",
		value: 0,
	},
	{
		name: "-1",
		value: -1,
	},
	{
		name: "-2",
		value: -2,
	},
	{
		name: "-3",
		value: -3,
	},
]);

// Used in the examination form to populate value in a select for both the left and right eyes
app.constant("LINE", [
	{
		name: "4.8",
		value: "_4_8",
	},
	{
		name: "6",
		value: "_6",
	},
	{
		name: "7.5",
		value: "_7_5",
	},
	{
		name: "9",
		value: "_9",
	},
	{
		name: "12",
		value: "_12",
	},
	{
		name: "15",
		value: "_15",
	},
	{
		name: "18",
		value: "_18",
	},
	{
		name: "21",
		value: "_21",
	},
	{
		name: "24",
		value: "_24",
	},
	{
		name: "30",
		value: "_30",
	},
	{
		name: "36",
		value: "_36",
	},
	{ 
		name: "42", 
		value: "_42",
	},
	{
		name: "48",
		value: "_48",
	},
	{
		name: "60",
		value: "_60",
	},
	{
		name: "120",
		value: "_120",
	},
	{
		name: "CF",
		value: "CF_30_CM",
	},
	{
		name: "HM",
		value: "HM_30_CM",
	},
	{
		name: "POL",
		value: "PL",
	},
	{
		name: "NPL",
		value: "NPL",
	},
]);

// Used in the examination form to populate value in a select for both the left and right eyes
app.constant("CYL", [
	{ name: "less than -10", value: "-100" },
	{ name: "-10", value: -10 },
	{ name: "-9.75", value: -9.75 },
	{ name: "-9.5", value: -9.5 },
	{ name: "-9.25", value: -9.25 },
	{ name: "-9.0", value: -9.0 },
	{ name: "-8.75", value: -8.75 },
	{ name: "-8.5", value: -8.5 },
	{ name: "-8.25", value: -8.25 },
	{ name: "-8.0", value: -8.0 },
	{ name: "-7.75", value: -7.75 },
	{ name: "-7.5", value: -7.5 },
	{ name: "-7.25", value: -7.25 },
	{ name: "-7.0", value: -7.0 },
	{ name: "-6.75", value: -6.75 },
	{ name: "-6.5", value: -6.5 },
	{ name: "-6.25", value: -6.25 },
	{ name: "-6.0", value: -6.0 },
	{ name: "-5.75", value: -5.75 },
	{ name: "-5.5", value: -5.5 },
	{ name: "-5.25", value: -5.25 },
	{ name: "-5.0", value: -5.0 },
	{ name: "-4.75", value: -4.75 },
	{ name: "-4.5", value: -4.5 },
	{ name: "-4.25", value: -4.25 },
	{ name: "-4.0", value: -4.0 },
	{ name: "-3.75", value: -3.75 },
	{ name: "-3.5", value: -3.5 },
	{ name: "-3.25", value: -3.25 },
	{ name: "-3.0", value: -3.0 },
	{ name: "-2.75", value: -2.75 },
	{ name: "-2.5", value: -2.5 },
	{ name: "-2.25", value: -2.25 },
	{ name: "-2.0", value: -2.0 },
	{ name: "-1.75", value: -1.75 },
	{ name: "-1.5", value: -1.5 },
	{ name: "-1.25", value: -1.25 },
	{ name: "-1.0", value: -1.0 },
	{ name: "-0.75", value: -0.75 },
	{ name: "-0.5", value: -0.5 },
	{ name: "-0.25", value: -0.25 },
	{ name: "0", value: 0 },
	{ name: "0.25", value: 0.25 },
	{ name: "0.5", value: 0.5 },
	{ name: "0.75", value: 0.75 },
	{ name: "1.0", value: 1.0 },
	{ name: "1.25", value: 1.25 },
	{ name: "1.5", value: 1.5 },
	{ name: "1.75", value: 1.75 },
	{ name: "2.0", value: 2.0 },
	{ name: "2.25", value: 2.25 },
	{ name: "2.5", value: 2.5 },
	{ name: "2.75", value: 2.75 },
	{ name: "3.0", value: 3.0 },
	{ name: "3.25", value: 3.25 },
	{ name: "3.5", value: 3.5 },
	{ name: "3.75", value: 3.75 },
	{ name: "4.0", value: 4.0 },
	{ name: "4.25", value: 4.25 },
	{ name: "4.5", value: 4.5 },
	{ name: "4.75", value: 4.75 },
	{ name: "5.0", value: 5.0 },
	{ name: "5.25", value: 5.25 },
	{ name: "5.5", value: 5.5 },
	{ name: "5.75", value: 5.75 },
	{ name: "6.0", value: 6.0 },
	{ name: "6.25", value: 6.25 },
	{ name: "6.5", value: 6.5 },
	{ name: "6.75", value: 6.75 },
	{ name: "7.0", value: 7.0 },
	{ name: "7.25", value: 7.25 },
	{ name: "7.5", value: 7.5 },
	{ name: "7.75", value: 7.75 },
	{ name: "8.0", value: 8.0 },
	{ name: "8.25", value: 8.25 },
	{ name: "8.5", value: 8.5 },
	{ name: "8.75", value: 8.75 },
	{ name: "9.0", value: 9.0 },
	{ name: "9.25", value: 9.25 },
	{ name: "9.5", value: 9.5 },
	{ name: "9.75", value: 9.75 },
	{ name: "10.0", value: 10.0 },
	{ name: "More than 10+", value: "100" },
]);

app.constant("DEVICE", [
	{ name: "iCare", value: "ICARE" },
	{ name: "Goldman", value: "GOLDMAN" },
	{ name: "Tonopen", value: "TONOPEN" },
	{ name: "Tonoref", value: "TONOREF" },
	{ name: "other", value: "OTHER" },
]);

app.constant("LENS_STATUS", [
	{ name: "Phakic", value: "PHAKIC" },
	{ name: "Pseudophakic", value: "PSEUDO_PHAKIC" },
	{ name: "Pseudophakic with PCO", value: "PSEUDO_PHAKIC_WITH_PCO" },
	{ name: "Aphakic", value: "APHAKIC" },
]);

app.constant("NUCLEAR_OPALESCENCE", [
	{ name: "Absent", value: "ABSENT" },
	{ name: "NO1", value: "NO1" },
	{ name: "NO2", value: "NO2" },
	{ name: "NO3", value: "NO3" },
	{ name: "NO4", value: "NO4" },
	{ name: "NO5", value: "NO5" },
	{ name: "NO6", value: "NO6" },
]);

app.constant("NUCLEAR_COLOUR", [
	{ name: "Absent", value: "ABSENT" },
	{ name: "NC1", value: "NC1" },
	{ name: "NC2", value: "NC2" },
	{ name: "NC3", value: "NC3" },
	{ name: "NC4", value: "NC4" },
	{ name: "NC5", value: "NC5" },
	{ name: "NC6", value: "NC6" },
]);

app.constant("CORTICAL", [
	{ name: "Absent", value: "ABSENT" },
	{ name: "C1", value: "C1" },
	{ name: "C2", value: "C2" },
	{ name: "C3", value: "C3" },
	{ name: "C4", value: "C4" },
	{ name: "C5", value: "C5" },
]);

app.constant("POST_SUBCAPSULAR", [
	{ name: "Absent", value: "ABSENT" },
	{ name: "P1", value: "P1" },
	{ name: "P2", value: "P2" },
	{ name: "P3", value: "P3" },
	{ name: "P4", value: "P4" },
	{ name: "P5", value: "P5" },
]);

app.constant("PUPIL_SIZE", [
	{ name: "2mm", value: "_2mm" },
	{ name: "3mm", value: "_3mm" },
	{ name: "4mm", value: "_4mm" },
	{ name: "5mm", value: "_5mm" },
	{ name: "6mm", value: "_6mm" },
	{ name: "7mm", value: "_7mm" },
	{ name: "8mm", value: "_8mm" },
	{ name: "9mm", value: "_9mm" },
]);

app.constant("MACULOPATHY", [
	{ name: "M0", value: "M0" },
	{ name: "M1", value: "M1" },
	{ name: "M2", value: "M2" },
	{ name: "M3", value: "M3" },
	{ name: "M4", value: "M4" },
	{ name: "M5", value: "M5" },
	{ name: "MT", value: "MT" },
	{ name: "No view", value: "NO_VIEW" },
]);

app.constant("RETINOPATHY", [
	{ name: "R0", value: "R0" },
	{ name: "R1", value: "R1" },
	{ name: "R2", value: "R2" },
	{ name: "R3", value: "R3" },
	{ name: "R4", value: "R4" },
	{ name: "R5", value: "R5" },
	{ name: "RT", value: "RT" },
	{ name: "No view", value: "NO_VIEW" },
]);

app.constant("LENS_TYPE", [
	{ name: "Monofocal", value: "NON_TORIC" },
	{ name: "Monofocal toric", value: "TORIC" },
	{ name: "Refractive EDoF", value: "EDOF" },
	{ name: "Refractive EDoF toric", value: "TORIC_EDOF" },
	{ name: "Diffractive/multifocal", value: "MULTIFOCAL" },
	{ name: "Diffractive/multifocal toric", value: "TORIC_MULTIFOCAL" },
	{ name: "Addon/phakic IOL/ICL", value: "NON_TORIC_ADDON" },
	{ name: "Addon/phakic IOL/ICL toric", value: "TORIC_ADDON" },
	{ name: "Other", value: "OTHER" },
]);

app.constant("LENSMODEL_MONOFOCAL", [
	{ name: "Alcon SN60WF/AU00T0", value: "SN60WF/AU00T0" },
	{ name: "Alcon Clareon", value: "Clareon" },
	{ name: "Alcon SA60AT", value: "SA60AT"},
	{ name: "Alcon MA60AC", value: "MA60AC"},
	{ name: "Alcon MA60MA", value: "MA60MA" },
	{ name: "Akreos Adapt AO", value: "Adapt AO"},
	{ name: "Aurolab Aurovue", value: "Aurolab Aurovue"},
	{ name: "B&L enVista", value: "enVista" },
	{ name: "RayOne Aspheric", value: "RayOne Aspheric" },
	{ name: "Tecnis Eyhance", value: "Tecnis Eyhance" },
	{ name: "Tecnis Monofocal", value: "Tecnis Monofocal" },
	{ name: "Tecnis Sensar", value: "Tecnis Sensar" },
	{ name: 'Odyssey', value: 'Odyssey'},
	{ name: 'Envy', value: 'Envy'},
]);

app.constant("LENSMODEL_MONOFOCAL_TORIC", [
	{ name: "Alcon Clareon", value: "Clareon" },
	{ name: "Alcon SN6ATx", value: "SN6ATx" },
	{ name: "B&L enVista", value: "enVista" },
	{ name: "RayOne Aspheric", value: "RayOne Aspheric" },
	{ name: "Tecnis Eyhance", value: "Tecnis Eyhance" },
	{ name: "Tecnis Monofocal", value: "Tecnis Monofocal" },
	{ name: "Teleon Custom", value: "Teleon Custom" },
	{ name: "Galaxy", value: "Galaxy" },
	{ name: 'Odyssey', value: 'Odyssey'},
	{ name: 'Envy', value: 'Envy'},
]);

app.constant("LENSMODEL_EDOF", [
	{ name: "Acufocus IC-8", value: "IC-8" },
	{ name: "Alcon Vivity", value: "Vivity" },
	// { name: "Lentis Comfort", value: "Comfort" },
	{ name: "RayOne EMV", value: "RayOne EMV" },
	{ name: "Tecnis PureSee", value: "Tecnis PureSee"},
	{ name: "Teleon Comfort", value: "Teleon Comfort"},
	{ name: "Teleon MF30", value: "Teleon MF30"},
	{ name: "Teleon Vario", value: "Teleon Vario"},
	{ name: "Teleon VarioMax", value: "Teleon VarioMax"},
	// { name: "SIFI Mini Well", value: "Mini Well" },
	// { name: "Tecnis Eyhance", value: "Eyhance" },
]);

app.constant("LENSMODEL_EDOF_TORIC", [
	{ name: "Alcon Vivity", value: "Vivity" },
	{ name: "RayOne EMV", value: "RayOne EMV" },
	{ name: "Tecnis PureSee", value: "Tecnis PureSee"},
	{ name: "Teleon Comfort", value: "Teleon Comfort"},
	{ name: "Teleon MF30", value: "Teleon MF30"},
	{ name: "Teleon Vario", value: "Teleon Vario"},
	{ name: "Teleon VarioMax", value: "Teleon VarioMax"},
	// { name: "Tecnis Eyhance", value: "Eyhance" },
	// { name: "Lentis Comfort", value: "Comfort" },
	// { name: "SIFI Mini Well", value: "Mini Well" },
]);

app.constant("LENSMODEL_MULTIFOCAL", [
	{ name: "Alcon PanOptix Pro", value: "PanOptix Pro" },
	{ name: "B&L Envy", value: "B&L Envy" },
	{ name: "B&L FineVision", value: "FineVision" },
	{ name: "ClearView 3", value: "ClearView 3" },
	{ name: "Galaxy", value: "Galaxy" },
	{ name: "Tecnis Odyssey", value: "Tecnis Odyssey" },
	{ name: "Tecnis Symfony", value: "Symfony" },
	{ name: "Tecnis Synergy", value: "Synergy" },
]);

app.constant("LENSMODEL_MULTIFOCAL_TORIC", [
	{ name: "Alcon PanOptix Pro", value: "PanOptix Pro" },
	{ name: "B&L Envy", value: "B&L Envy" },
	{ name: "B&L FineVision", value: "FineVision" },
	{ name: "Galaxy", value: "Galaxy" },
	{ name: "Tecnis Odyssey", value: "Tecnis Odyssey" },
	{ name: "Tecnis Symfony", value: "Symfony" },
	{ name: "Tecnis Synergy", value: "Synergy" },
]);


app.constant("LENSMODEL_ADDON", [
	{ name: "Medicontur 1stQ", value: "1stQ" },
	{ name: "Rayner Sulcoflex", value: "Sulcoflex" },
	{ name: "Visian ICL", value: "Visian ICL" },
	{ name: "Viva ICL", value: "Viva ICL" },
]);

app.constant("LENSMODEL_ADDON_TORIC", [
	{ name: "Medicontur 1stQ", value: "1stQ" },
	{ name: "Rayner Sulcoflex", value: "Sulcoflex" },
	{ name: "Visian ICL", value: "Visian ICL" },
	{ name: "Viva ICL", value: "Viva ICL" },
]);



app.constant("LENSMODEL", [
	{ name: "Alcon SN60WF/AU00T0", value: "SN60WF/AU00T0" },
	{ name: "Alcon SA60WF", value: "SA60WF" },
	{ name: "Alcon MA60MA", value: "MA60MA" },
	{ name: "Alcon SN6ATx", value: "SN6ATx" },
	{ name: "Alcon Clareon", value: "Clareon" },
	{ name: "Alcon MA60AC", value: "MA60AC"},
	{ name: "Alcon SA60AT", value: "SA60AT"},
	{ name: "Alcon Vivity", value: "Vivity" },
	{ name: "Alcon PanOptix Pro", value: "PanOptix Pro" },
	{ name: "Akreos Adapt AO", value: "Adapt AO"},
	{ name: "Acufocus IC-8", value: "IC-8" },
	{ name: "B&L enVista", value: "enVista" },
	{ name: "B&L FineVision", value: "FineVision" },
	{ name: "Lentis Comfort", value: "Comfort" },
	{ name: "Medicontur 1stQ", value: "1stQ" },
	{ name: "Rayner Sulcoflex", value: "Sulcoflex" },
	{ name: "SIFI Mini Well", value: "Mini Well" },
	{ name: "Teleon Comfort", value: "Teleon Comfort"},
	{ name: "Tecnis Monofocal", value: "Tecnis Monofocal" },
	{ name: "Tecnis Eyhance", value: "Eyhance" },
	{ name: "Tecnis PureSee", value: "Tecnis PureSee"},
	{ name: "Tecnis Symfony", value: "Symfony" },
	{ name: "Tecnis Synergy", value: "Synergy" },
	{ name: "Teleon Custom", value: "Teleon Custom" },
	{ name: "Teleon MF30", value: "Teleon MF30"},
	{ name: "Teleon Vario", value: "Teleon Vario"},
	{ name: "Teleon VarioMax", value: "Teleon VarioMax"},
	
]);

app.constant("REACTIONS", [
	{ name: "Rash", value: "RASH" },
	{ name: "GI upset", value: "GI_UPSET" },
	{ name: "Anaphylaxis", value: "ANAPHYLAXIS" },
]);

app.constant("ANAESTHETIC", [
	{ name: "Topical/subtenons", value: "TOPICAL_SUBTENONS" },
	{ name: "Local with sedation", value: "LOCAL_SEDATION" },
	{ name: "General", value: "GENERAL" },
]);

app.constant("REASON", [
	{ name: "Anxiety", value: "ANXIETY" },
	{ name: "Tremor/positioning", value: "TREMOR_POSITIONING" },
	{ name: "Patient preference", value: "PATIENT_PREFERENCE" },
	{ name: "Cognitive impairment", value: "COGNITIVE_IMPAIRMENT" },
	{ name: "Other", value: "OTHER" },
]);

app.constant("VISUALACUITYLINE", [
	{ name: "4.8", value: "_4_8"},
	{ name: "6", value: "_6" },
	{ name: "7.5", value: "_7_5" },
	{ name: "9", value: "_9" },
	{ name: "12", value: "_12" },
	{ name: "15", value: "_15" },
	{ name: "18", value: "_18" },
	{ name: "21", value: "_21" },
	{ name: "24", value: "_24" },
	{ name: "30", value: "_30" },
	{ name: "36", value: "_36" },
	{ name: "42", value: "_42" },
	{ name: "48", value: "_48" },
	{ name: "60", value: "_60" },
	{ name: "120", value: "_120" },
	{ name: "CF", value: "CF_30_CM" },
	{ name: "HM", value: "HM_30_CM" },
	{ name: "PL", value: "PL" },
	{ name: "NPL", value: "NPL" },
]);

app.constant("OPERATIONPROCEDURE", [
	{ name: "Phaco and IOL", id: "PHACO_IOL" },
	{ name: "Phaco", id: "PHACO_NO_IOL" },
	{ name: "Addon/phakic IOL/ICL implantation", id: "IOL_ADDON" },
	{ name: "IOL implantation", id: "IOL_IMPLANTATION" },
	{ name: "IOL exchange", id: "IOL_EXCHANGE" },
	{ name: "Toric IOL axis realignment", id: "TORIC_IOL_AXIS_REALIGNMENT" },
	{ name: "Other", id: "OTHER"},
]);

app.constant("OPERATIONANAESTHETIC", [
	{ name: "Topical", id: "TOPICAL" },
	{ name: "Topical with intracameral", id: "TOPICAL_INTRACAMERAL" },
	{ name: "Sub-Tenon’s", id: "SUBTENONS" },
	{ name: "Peribulbar", id: "PERIBULBAR" },
	// { name: "topical sub tenons", id: "TOPICAL_SUBTENONS" },
	{ name: "Topical/subtenons", id: "TOPICAL_SUBTENONS" },
	{ name: "Local", id: "LOCAL" },
	{ name: "Local with sedation", id: "LOCAL_SEDATION" },
	{ name: "General", id: "GENERAL" },
]);

app.constant("INCISIONSIZE", [
	{ name: "1.1", id: "1.1" },
	{ name: "1.8", id: "1.8" },
	{ name: "2.0", id: "2.0" },
	{ name: "2.2", id: "2.2" },
	{ name: "2.4", id: "2.4" },
	{ name: "2.6", id: "2.6" },
	{ name: "2.8", id: "2.8" },
	{ name: "3.0", id: "3.0" },
	{ name: "3.2", id: "3.2" },
	{ name: "3.4", id: "3.4" },
]);

app.constant("OVD", [
	{ name: "Healon", value: "Healon" },
	{ name: "Healon 5", value: "Healon 5"},
	{ name: "Healon GV Pro", value: "Healon GV Pro" },
	{ name: "Provisc", value: "Provisc"},
	{ name: "Viscoat", value: "Viscoat" },
	{ name: "Duovisc", value: "Duovisc" },
	{ name: "Aurogel", value: "Aurogel" },
	{ name: "Discovisc", value: "Discovisc" },
	{ name: "Other", value: "Other" },
]);

// app.constant("PUPILEXPANDER", [
// 	{ name: "None", value: "NONE" },
// 	{ name: "Malyugan ring", value: "MALYUGAN_RING" },
// 	{ name: "Iris hooks", value: "IRIS_HOOKS" },
// 	{ name: "other", value: "OTHER" },
// ]);

app.constant("PUPILEXPANDER", [
	{ name: "None", id: "NONE" },
	{ name: "Malyugan ring", id: "Malyugan ring" },
	{ name: "Iris hooks", id: "Iris hooks" },
]);

app.constant("CCCTECHNIQUE", [
	{ name: "Cystotome + Rhexis forceps", id: "Cystotome + Rhexis forceps" },
	{ name: "Rhexis forceps", id: "Rhexis forceps" },
	{ name: "Cystotome", id: "Cystotome" },
]);

app.constant("HYDRODISSECTION", [
	{ name: "BSS", value: "BSS" },
	{ name: "Anaesthetic", value: "ANAESTHETIC" },
	{ name: "OVD", value: "OVD" },
	{ name: "None", value: "NONE" },
]);

app.constant("PHACOMACHINE", [
	{ name: "Infinity", value: "Infinity" },
	{ name: "Constellation", value: "Constellation" },
	{ name: "Centurion", value: "Centurion" },
	{ name: "Unity", value: "Unity" },
	{ name: "Stellaris", value: "Stellaris" },
	{ name: "Whitestar Signature", value: "Whitestar Signature" },
	{ name: "Veritas", value: "Veritas"},
	{ name: "Sophi", value: "Sophi"},
	{ name: "Ortli", value: "Ortli"},
	{ name: "Nidek Cube Alpha", value: "Nidek Cube Alpha"},
	{ name: 'Quatera 700', value: 'Quatera 700'},
	{ name: "Other", value: "Other" },
]);

app.constant("PHACOTECHNIQUE", [
	{ name: "Divide and conquer", id: "Divide and conquer" },
	{ name: "Stop and chop", id: "Stop and chop" },
	{ name: "Horizontal chop", id: "Horizontal chop" },
	{ name: "Vertical chop", id: "Vertical chop" },
	{ name: "Bimanual", id: "Bimanual" },
]);

app.constant("PHACOIRRIGATION", [
	{ name: "Bimanual", id: "Bimanual" },
	{ name: "Unipak", id: "Unipak" },
	{ name: "Coaxial", id: "Coaxial" },
	{ name: "90 deg coaxial", id: "90 deg coaxial" },
]);

app.constant("LENSPLACEMENT", [
	{ name: "In the bag", id: "In the bag" },
	{ name: "Sulcus", id: "Sulcus" },
	{ name: "Optic capture", id: "Optic capture" },
	{ name: "Reverse optic capture", id: "Reverse optic capture" },
	{ name: "Iris fixated", id: "Iris fixated" },
	{ name: "Scleral fixated", id: "Scleral fixated" },
	{ name: "Anterior chamber", id: "Anterior chamber"}
]);

app.constant("INTRAOPERATIVEMEDICATIONS", [
	{ name: 'Intracameral cefazolin', id: 'Intracameral cefazolin'},
	{ name: "Intracameral cefuroxime", id: "Intracameral cefuroxime" },
	{ name: "Intracameral miochol", id: "Intracameral miochol" },
	{ name: "Intracameral miostat", id: "Intracameral miostat" },
	{ name: "Intracameral moxifloxacin", id: "Intracameral moxifloxacin" },
	{ name: "Subconjunctival cefazolin", id: "Subconjunctival cefazolin" },
	{ name: "Subconjunctival gentamycin", id: "Subconjunctival gentamycin"},
	{ name: "Subconjunctival dexamethasone", id: "Subconjunctival dexamethasone" },

	{ name: "Topical oc. chloramphenicol", id: "Topical oc. chloramphenicol" },
	{ name: "Topical g. chloramphenicol", id: "Topical g. chloramphenicol" },
	{ name: "Topical oc. maxitrol", id: "Topical oc. maxitrol" },
	{ name: "Topical oc. maxidex", id: "Topical oc. maxidex" },
	{ name: "Topical g. prednisolone", id: "Topical g. prednisolone" },
	{ name: "Subconjunctival triamcinolone 2mg", id: "Subconjunctival triamcinolone 2mg"},
	{ name: "Subconjunctival triamcinolone 4mg", id: "Subconjunctival triamcinolone 4mg"},
	{ name: "Subconjunctival triamcinolone 10mg", id: "Subconjunctival triamcinolone 10mg"}
]);

app.constant("MEDICATIONS", [
	"g. Chloramphenicol 0.5%",
	"g. Chloramphenicol 0.5% minims",
	"g. Prednisolone 1%",
	"g. Prednisolone 0.5% minims",
	"g. Maxidex 0.1%",
	"g. Maxitrol",
	"g. Voltaren",
	"g. Acular 0.5%",
	"oc. Chloramphenicol 1%",
	"oc. Maxidex 0.1%",
	"oc. Maxitrol",
	"g. Ciprofloxacin 0.3%",
	"g. Polytears",
	"Acetazolamide",
	"Paracetamol",
	"Diclofenac SR",
	"Codeine"
]);

app.constant("POSTOPERATIVEMAP", [
	{
		med: "g. Chloramphenicol 0.5%",
		dose: "1 drop",
		frequency: 4,
		route: null,
		duration: 14,
	},
	{
		med: "g. Chloramphenicol 0.5% minims",
		dose: "1 drop",
		frequency: 4,
		route: null,
		duration: 14,
	},
	{
		med: "g. Prednisolone 1%",
		dose: "1 drop",
		frequency: 4,
		route: null,
		duration: 28,
	},
	{
		med: "g. Prednisolone 0.5% minims",
		dose: "1 drop",
		frequency: 4,
		route: null,
		duration: 28,
	},
	{
		med: "g. Maxidex 0.1%",
		dose: "1 drop",
		frequency: 4,
		route: null,
		duration: 28,
	},
	{
		med: "g. Maxitrol",
		dose: "1 drop",
		frequency: 4,
		route: null,
		duration: 28,
	}, 
	{
		med: "g. Voltaren",
		dose: "1 drop",
		frequency: 4,
		route: null,
		duration: 28,
	},
	{
		med: "g. Acular 0.5%",
		dose: "1 drop",
		frequency: 4,
		route: null,
		duration: 28,
	},
	{
		med: "oc. Chloramphenicol 1%",
		dose: "apply",
		frequency: 4,
		route: null,
		duration: 14,
	},
	{
		med: "oc. Maxidex 0.1%",
		dose: "apply",
		frequency: 4,
		route: null,
		duration: 28,
	},
	{
		med: "oc. Maxitrol",
		dose: "apply",
		frequency: 4,
		route: null,
		duration: 28,
	},
	{
		med: "g. Ciprofloxacin 0.3%",
		dose: "1 drop",
		frequency: 4,
		route: null,
		duration: 14,
	},
	{
		med: "g. Polytears",
		dose: "1 drop",
		frequency: 4,
		route: null,
		duration: 28,
	},
	{
		med: "Acetazolamide",
		dose: "250mg",
		frequency: 3,
		route: "ORAL",
		duration: 1,
	},
	{
		med: "Paracetamol",
		dose: "1gm",
		frequency: 4,
		route: "ORAL",
		duration: 36,
	},
	{
		med: "Diclofenac SR",
		dose: "75mg",
		frequency: 2,
		route: "ORAL",
		duration: 7,
	},
	{
		med: "Codeine",
		dose: "30-60mg",
		frequency: 3,
		route: "ORAL",
		duration: 7,
	},
]);

app.constant("DOSE", [
	{ name: "DOSE 1", value: "dose_1" },
	{ name: "DOSE 2", value: "dose_2" },
	{ name: "DOSE 3", value: "dose_3" },
]);

app.constant("ROUTE", [
	{ name: "Right Eye", value: "OD" },
	{ name: "Left Eye", value: "OS" },
	{ name: "Both Eyes", value: "BOTH" },
	{ name: "Oral", value: "ORAL" },
]);

app.constant("VISUAL_POTENTIAL", [
	{ value: "_BETTER_THAN_6By12", name: "Better than 6/12" },
	{ value: "_BETTER_THAN_6By12_TO_6By36", name: "6/12 to 6/36" },
	{ value: "_WORSE_6By36", name: "Worse than 6/36" },
])

app.constant("LIFE_QUALITY_QUESTIONS",[
	{ model:"qol_C_1", name: "Reading text in newspapers"},
	{ model:"qol_C_2", name: "Recognising the faces of people you meet"},
	{ model:"qol_C_3", name: "Seeing the prices of goods when shopping"},
	{ model:"qol_C_4", name: "Seeing to walk on uneven surfaces, e.g. cobblestones"},
	{ model:"qol_C_5", name: "Seeing to do handicrafts woodwork etc"},
	{ model:"qol_C_6", name: "Reading subtitles on TV"},
	{ model:"qol_C_7", name: "Seeing to engage in an activity/hobby that you are interested in"},
])

app.constant("LIFE_QUALITY_QUESTIONS_REFERRAL",[
	{ model:"q3_sight_reading_text", name: "Reading text in newspapers"},
	{ model:"q4_sight_face_recognition", name: "Recognising the faces of people you meet"},
	{ model:"q5_sight_seeing_prices", name: "Seeing the prices of goods when shopping"},
	{ model:"q6_sight_walking", name: "Seeing to walk on uneven surfaces, e.g. cobblestones"},
	{ model:"q7_sight_handcraft", name: "Seeing to do handicrafts woodwork etc"},
	{ model:"q8_sight_reading_subtitles", name: "Reading subtitles on TV"},
	{ model:"q9_sight_engage_activities", name: "Seeing to engage in an activity/hobby that you are interested in"},
])

app.constant("MEDICAL_INSURANCE",[
	{ value: "PUBLIC", name: "Public" },
	{ value: "AA", name: "AA" },
	{ value: "ACC", name: "ACC" },
	{ value: "ACCURO", name: "Accuro" },
	{ value: "AIA", name: "AIA" },
	{ value: "NIB", name: "NIB" },
	{ value: "OTHER", name: "Other" },
	{ value: "PARTNERS_LIFE", name: "Partners life" },
	{ value: "SOUTHERN_CROSS", name: "Southern Cross" },
	{ value: "UNIMED", name: "UniMed" },
	{ value: "NO_INSURANCE", name: "No insurance / self-paid" },
])

app.constant("FEATURES",{
	PREMIUMLENS: true,
})

// The premium IOLs a surgeon can quote, in the order the pre-op price step lists them. `key` is the
// lens's property on the pre-op request body, `name` the API's LensName. The toric monofocals take a
// toric price only: their non-toric version is included in standard pricing, and the API refuses a
// price for it. Standard monofocal (MONOFOCAL_STANDARD) is always included, so it has no price here.
app.constant("PREMIUM_LENSES", [
	{ key: "monofocal", name: "MONOFOCAL", label: "Tecnis toric", toricOnly: true },
	{ key: "alcon_toric", name: "ALCON_TORIC", label: "Alcon Toric", toricOnly: true },
	{ key: "rayone", name: "RAYONE", label: "RayOne toric", toricOnly: true },
	{ key: "lentis", name: "LENTIS", label: "Lentis custom toric", toricOnly: true },
	{ key: "eyhance", name: "EYHANCE", label: "Eyhance" },
	{ key: "rayone_emv", name: "RAYONE_EMV", label: "RayOne EMV" },
	{ key: "pure_see", name: "PURE_SEE", label: "PureSee" },
	{ key: "vivity", name: "VIVITY", label: "Vivity" },
	{ key: "comfort", name: "COMFORT", label: "Comfort" },
	{ key: "vario", name: "VARIO", label: "Vario" },
	{ key: "mf30", name: "MF30", label: "MF30" },
	{ key: "varioMax", name: "VARIO_MAX", label: "VarioMax" },
	{ key: "symfony", name: "SYMFONY", label: "Symfony" },
	{ key: "synergy", name: "SYNERGY", label: "Synergy" },
	{ key: "pan_optix", name: "PAN_OPTIX", label: "PanOptix Pro" },
	{ key: "galaxy", name: "GALAXY", label: "Galaxy" },
	{ key: "clearview", name: "CLEARVIEW", label: "ClearView 3" },
])

app.constant("USER_TYPE",[
	{ value: "OPTOMETRIST", name: "Optometrist" },
	{ value: "GP", name: "GP"},
	{ value: "OPHTHALMOGIST", name: "Ophthalmogist" },
	{ value: "REGISTERED_NURSE", name: "Registered Nurse"}, 
	{ value: "CLINICAL_NURSE_SPECIALIST", name: "Clinical Nurse Specialist"},
	{ value: "REGISTRAR", name: "Registrar"}
])

app.constant("USER_TITLE",[
	{ value: "DR", name: "Dr"},
	{ value: "PROF", name: "Prof"},
	{ value: "MR", name: "Mr" },
	{ value: "MRS", name: "Mrs" },
	{ value: "MS", name: "Ms" },
])

app.constant("USER_ROLE",[
	{ id: "ADMIN", label: "Admin"},
	{ id: "GP", label: "GP"},
	{ id: "OPTOMETRIST", label: "Optometrist"}, 
	{ id: "TECHNICIAN", label: "Technician"},
	{ id: "REGISTERED_NURSE", label: "Registered Nurse"},
	{ id: "CLINICAL_NURSE_SPECIALIST", label: "Clinical Nurse Specialist"}, 
	{ id: "REGISTRAR", label: "Registrar"},
	{ id: "OPHTHALMOLOGIST", label: "Ophthalmologist"},
	{ id: "PRACTICE_ADMIN", label: "Practice Admin" },
	{ id: "PRACTICE_MANAGER", label: "Practice Manager" },
	// { id: "REFERRER", label: "Referrer (removed)" },
])

app.constant("PRACTICE_TYPE",[
	{value: "OPTOMETRY", name: "Optometry"},
	{value: "PRIVATE", name: "Private[ophthalmologist]"},
	{value: "DHB_PUBLIC", name: "Public hospital"},
	{value: "GP", name: "GP"},
	{value: "THEATRE", name: "Theatre"},
])

app.constant("DHB_LIST",[
	{value: "AUCKLAND", name: "AUCKLAND"},
	{value: "BAY_OF_PLENTY", name: "BAY_OF_PLENTY"},
	{value: "CANTERBURY", name: "CANTERBURY"},
	{value: "CAPITAL_AND_COST", name: "CAPITAL_AND_COST"},
	{value: "COUNTIES_MANUKAU", name: "COUNTIES_MANUKAU"},
	{value: "HAWKES_BAY", name: "HAWKES_BAY"},
	{value: "HUTT_VALLEY", name: "HUTT_VALLEY"},
	{value: "LAKES", name: "LAKES"},
	{value: "MID_CENTRAL", name: "MID_CENTRAL"},
	{value: "NELSON_MARLBOROUGH", name: "NELSON_MARLBOROUGH"},
	{value: "NORTHLAND", name: "NORTHLAND"},
	{value: "SOUTH_CANTERBURY", name: "SOUTH_CANTERBURY"},
	{value: "SOUTHERN", name: "SOUTHERN"},
	{value: "TAIRAWHITI", name: "TAIRAWHITI"},
	{value: "TARANAKI", name: "TARANAKI"},
	{value: "WAIKATO", name: "WAIKATO"},
	{value: "WAIRARAPA", name: "WAIRARAPA"},
	{value: "WAITEMATA", name: "WAITEMATA"},
	{value: "WEST_COST", name: "WEST_COST"},
	{value: "WHANGANUI", name: "WHANGANUI"},
])

app.constant("DHB_DISPLAY_NAME",{
	AUCKLAND: "Auckland",
	BAY_OF_PLENTY: "Bay of Plenty",
	CANTERBURY: "Canterbury",
	CAPITAL_AND_COST: "Capital and Coast",
	COUNTIES_MANUKAU: "Counties Manukau",
	HAWKES_BAY: "Hawke's Bay",
	HUTT_VALLEY: "Hutt Valley",
	LAKES: "Lakes",
	MID_CENTRAL: "MidCentral",
	NELSON_MARLBOROUGH: "Nelson Marlborough",
	NORTHLAND: "Northland",
	SOUTH_CANTERBURY: "South Canterbury",
	SOUTHERN: "Southern",
	TAIRAWHITI: "Tairawhiti",
	TARANAKI: "Taranaki",
	WAIKATO: "Waikato",
	WAIRARAPA: "Wairarapa",
	WAITEMATA: "Waitemata",
	WEST_COST: "West Coast",
	WHANGANUI: "Whanganui",
})

app.constant("NHI_SERVICE_ERROR",
	{
		title: "The MoH NHI service has failed to return a result",
		body: "We apologise for the inconvenience. Please enter the details manually or try again later."
	}
)

app.constant("CONFIG", {
	NHI_ADDRESS: true
});

app.constant("POPULATE_DATA_SUCCESS", "The most recent clinical examination findings on record have been preloaded - please update any values that have changed");

app.constant("INJECTIONPROCEDURE", [
	{ name: "Intravitreal injection", id: "INTRAVITREAL_INJECTION" },
	{ name: "Intravitreal implant", id: "INTRAVITREAL_IMPLANT" },
	{ name: "Subtenons injection", id: "SUBTENONS_INJECTION" },
	{ name: "Orbital floor injection", id: "ORBITAL_FLOOR_INJECTION" },
	{ name: "Subconjunctival injection", id: "SUBCONJUNCTIVAL_INJECTION" },
	{ name: "Intravitreal tap and inject", id: "INTRAVITREAL_TAP_AND_INJECT" },
]);

app.constant("INDICATIONTYPE", [
	{ name: "Neovascular Age-related Macular Degeneration", id: "NEOVASCULAR_AMD" },
	{ name: "Retinal Angiomatous Proliferation (RAP)", id: "RAP" },
	{ name: "Polypoidal Choroidal Vasculopathy (PCV)", id: "PCV" },
	{ name: "Central retinal vein occlusion (CRVO)", id: "CENTRAL_RETINAL_VO" },
	{ name: "Branch retinal vein occlusion (BRVO)", id: "BRANCH_RETINAL_VO" },
	{ name: "Hemi retinal vein occlusion", id: "HEMI_RETINAL_VO"},
	{ name: "Diabetic macular oedema (DMO)", id: "DMO"},
	{ name: "Diabetic retinopathy (DR)", id: "DR"},
	{ name: "Diabetic macular oedema AND retinopathy", id: "DMO_AND_DR"},
	{ name: "Axial Myopia", id: "AXIAL_MYOPIA"},
	{ name: "Uveitis", id: "UVEITIS"},
	{ name: "Retinopathy of Prematurity (ROP)", id: "ROP"},
	{ name: "Cystoid Macular Oedema (CMO)", id: "CMO"},
	{ name: "Endophthalmitis", id: "ENDOPHTHALMITIS"},
	{ name: "Thyroid Eye Disease", id: "THYROID"},
	{ name: "Lymphoproliferative disease", id: "LYMPHOPROLIFERATIVE"},
	{ name: "Corneal neovascularisation", id: "CORNEAL_NEO"},
	{ name: "Other", id: "OTHER" },
]);

app.constant("OCULARTYPE", [
	{ name: "Early AMD", id: "EARLY_AMD" },
	{ name: "Geographic Atrophy", id: "GEOGRAPHIC_ATROPHY" },
	{ name: "nAMD", id: "NAMD" },
	{ name: "Diabetic retinopathy", id: "DIABETIC_RETINOPATHY" },
	{ name: "Axial myopia", id: "AXIAL_MYOPIA" },
	{ name: "Clinically significant media opacity", id: "CLINICALLY_SIGNIFICANT_OPACITY" },
	{ name: "Pseudophakia", id: "PSEUDOPHAKIA" },
	{ name: "Optic neuropathy including glaucoma", id: "OPTIC_NEUROPATHY_GLAUCOMA" },
	{ name: "Posterior uveitis", id: "POSTERIOR_UVEITIS" },
	{ name: "Vitreomacular traction/premacular fibrosis", id: "VITREOMACULAR_TRACTION_PREMACULAR" },
	{ name: "Amblyopia", id: "AMBLYOPIA" },
	{ name: "Retinal vascular disease", id: "RETINAL_VASCULAR_DISEASE" },
	{ name: "Yag Capsulotomy", id: "YAG_CAPSULOTOMY" },
	{ name: "Other macular pathology", id: "OTHER_MACULAR_PATHOLOGY" },
	{ name: "Vitrectomy", id: "VITRECTOMY" },
]);

app.constant("INJECTIONANAESTHETIC", [
	{ name: "Topical", id: "TOPICAL" },
	{ name: "Subconjunctival", id: "SUBCONJUNCTIVAL" },
	{ name: "Sub-Tenon’s", id: "SUBTENONS" },
	{ name: "Peribulbar", id: "PERIBULBAR" },
	{ name: "General", id: "GENERAL" },
]);

app.constant("INJECTIONPREPARATION", [
	{ name: "Povidone-Iodine", id: "POVIDONE_IODINE" },
	{ name: "Chlorhexidine", id: "CHLORHEXIDINE" },
	{ name: "None", id: "NONE" },
]);

app.constant("INJECTIONLOCATION", [
	{ name: "Superior", id: "SUPERIOR" },
	{ name: "Superior-temporal", id: "SUPERIOR_TEMPORAL" },
	{ name: "Temporal", id: "TEMPORAL" },
	{ name: "Inferior-temporal", id: "INFERIOR_TEMPORAL" },
	{ name: "Inferior", id: "INFERIOR" },
	{ name: "Inferior-nasal", id: "INFERIOR_NASAL" },
	{ name: "Nasal", id: "NASAL" },
	{ name: "Superior-nasal", id: "SUPERIOR_NASAL" },
]);

app.constant("DISTANCELIMBUS", [
	{ name: "1.0", id: "_1mm" },
	{ name: "1.5", id: "_1_5mm" },
	{ name: "2.0", id: "_2mm" },
	{ name: "2.5", id: "_2_5mm" },
	{ name: "3.0", id: "_3mm" },
	{ name: "3.5", id: "_3_5mm" },
	{ name: "4.0", id: "_4mm" },
	{ name: "4.5", id: "_4_5mm" },
	{ name: "5.0", id: "_5mm" },
]);

app.constant("INTRAVITREAL_MEDICATION", [
	{ name: "Bevacizumab (Avastin)", id: "BEVACIZUMAB" },
	{ name: "Aflibercept (Eylea)", id: "AFLIBERCEPT" },
	{ name: "Ranabizumab (Lucentis)", id: "RANABIZUMAB" },
	{ name: "Triamcinolone acetonide", id: "TRIAMCINOLONE_ACETONIDE" },
	{ name: "Methotrexate", id: "METHOTREXATE" },
	{ name: "Faricimab-svoa (Vabysmo)", id: "FARICIMAB_SVOA" },
	{ name: "Zaltrap/Ziv-Aflibercept", id: "ZALTRAP" },
]);

app.constant("INTRAVITREAL_IMPLANT_MEDICATION", [
	{ name: "Dexamethasone implant (Ozurdex)", id: "DEXAMETHASONE_IMPLANT" },
]);

app.constant("SUBTENONS_INJECTION_MEDICATION", [
	{ name: "Triamcinolone acetonide", id: "TRIAMCINOLONE_ACETONIDE" },
]);

app.constant("ORBITAL_FLOOR_MEDICATION", [
	{ name: "Triamcinolone acetonide", id: "TRIAMCINOLONE_ACETONIDE" },
]);

app.constant("SUBCONJUNCTIVAL_INJECTION_MEDICATION", [
	{ name: "Dexamethasone", id: "DEXAMETHASONE" },
	{ name: "Bevacizumab (Avastin)", id: "BEVACIZUMAB" },
	{ name: "Triamcinolone acetonide", id: "TRIAMCINOLONE_ACETONIDE" },
]);

app.constant("INTRAVITREAL_TAP_INJECT_MEDICATION", [
	{ name: "Vitreous Tap", id: "VITREOUS_TAP" },
	{ name: "Cefazolin", id: "CEFAZOLIN" },
	{ name: "Vancomycin", id: "VANCOMYCIN" },
	{ name: "Amikacin", id: "AMIKACIN" },
	{ name: "Ceftazidime", id: "CEFTAZIDIME" },
]);

app.constant("AUTHENTICATION_STATE", {
	normal: 0,
	waitingMFACode: 1,
	configMFA: 2,
	updateTempPassword: 3
});

// short is how the PDFs write the correction after an acuity (BCVACorrectionType's display value).
app.constant("CORRECTION_TYPE", [
	{ name: "Spectacles", value: "SPECTACLES", short: "Gl" },
	{ name: "Soft contact lens", value: "SOFT_CONTACT_LENS", short: "Soft CL" },
	{ name: "Rgp contact lens", value: "RGP_CONTACT_LENS", short: "RGP CL" },
	{ name: "Scleral contact lens", value: "SCLERAL_CONTACT_LENS", short: "Scl CL" },
]);

app.constant("REFERRAL_REASON_LEGACY", [
	{ name: "Cataract", value: "CATARACT" },
	{ name: "Cornea", value: "CORNEA" },
	{ name: "Glaucoma", value: "GLAUCOMA" },
	{ name: "Retina", value: "RETINA" },
	{ name: "Uveitis", value: "UVEITIS" },
	{ name: "Neuro Ophthalmology", value: "NEURO_OPHTHALMOLOGY" },
	{ name: "Paediatrics and Strabismus", value: "PAEDIATRICS_AND_STRABISMUS" },
	{ name: "Oculoplastics (Eyelid and Orbit)", value: "OCULOPLASTICS_EYELID_AND_ORBIT" },
	{ name: "Other", value: "OTHER" },
]);

app.constant("REFERRAL_REASON_OPHTHALMOLOGIST", [
	{ name: "Cataract", value: "CATARACT" },
	{ name: "Cornea", value: "CORNEA" },
	{ name: "Glaucoma", value: "GLAUCOMA" },
	{ name: "Retina", value: "RETINA" },
	{ name: "Uveitis", value: "UVEITIS" },
	{ name: "Neuro Ophthalmology", value: "NEURO_OPHTHALMOLOGY" },
	{ name: "Paediatrics and Strabismus", value: "PAEDIATRICS_AND_STRABISMUS" },
	{ name: "Oculoplastics (Eyelid and Orbit)", value: "OCULOPLASTICS_EYELID_AND_ORBIT" },
	{ name: "Refractive Surgery", value: "REFRACTIVE_SURGERY" },
	// { name: "ACC", value: "ACC" },
]);

app.constant("REFERRAL_REASON_OPTOMETRIST", [
	{ name: "Dry Eye", value: "DRY_EYE" },
	{ name: "Specialty Contact Lenses", value: "SPECIALTY_CONTACT_LENSES" },
	{ name: "Myopia Management", value: "MYOPIA_MANAGEMENT" },
	{ name: "Spectacle Update", value: "SPECTACLE_UPDATE" },
]);

app.constant("REFERRAL_REASON_RESTRICTED", [
	{ name: "Photobiomodulation", value: "PHOTOBIOMODULATION" },
]);

app.constant("REFERRAL_REASON_COMMON", [
	{ name: "Other", value: "OTHER" },
]);

app.constant("REFERRAL_PRIORITY", [
	{ name: "Ideally seen within next 5 days (urgent priority - please follow up this referral with a phone call to notify the doctor or hospital)", value: "URGENT" },
	{ name: "See as soon as possible (high priority)", value: "HIGH" },
	{ name: "See when available (routine priority)", value: "ROUTINE" },
]);

// How long a referral is valid for. `value` is what the referral is stored and read back as;
// `code` is what an ECLIPSE claim made against it carries. Held in one place because both ends
// have to agree: the document uploader writes these against a referral and the ECLIPSE claim
// widget reads them back off it.
app.constant("REFERRAL_PERIOD_TYPE", [
	{ value: "STANDARD", code: "S", name: "Standard" },
	{ value: "NON_STANDARD", code: "N", name: "Non-standard" },
	{ value: "INDEFINITE", code: "I", name: "Indefinite" },
]);

app.constant("FILE_TYPES", {
	image: [
		{ id: "BIOMETRY", name: "Biometry" },
		{ id: "OCT_MACULA", name: "OCT macula" },
		{ id: "OCT_GLAUCOMA", name: "OCT glaucoma" },
		{ id: "OCT_ANTERIOR_SEGMENT", name: "OCT anterior segment" },
		{ id: "VISUAL_FIELD", name: "Visual field" },
		{ id: "CORNEAL_TOMOGRAPHY", name: "Corneal tomography" },
		{ id: "IMAGE", name: "Image" },
		{ id: "REFERRAL", name: "Referral" },
		{ id: "CLINICAL_NOTES", name: "Clinical notes" },
		{ id: "CLINIC_LETTER", name: "Clinic letter" },
		{ id: "AGREEMENT_TO_TREATMENT", name: "Agreement to treatment" },
		{ id: "CATQUEST", name: "Catquest" },
		{ id: "SCANNED_HISTORIC_NOTES", name: "Scanned historic notes" },
		{ id: "SCANNED_OPERATION_NOTE", name: "Scanned operation note" },
		{ id: "DISCHARGE_SUMMARY", name: "Discharge summary" },
		{ id: "HISTOLOGY", name: "Histology" },
		{ id: "LAB_RESULTS", name: "Lab results " },
		{ id: "AI_ANALYSIS", name: "AI Analysis" },
		{ id: "AI_ANALYSIS_FAILED", name: "AI Analysis failed" },
		{ id: "OTHER", name: "Other" },
	],
	word: [
		{ id: "CLINICAL_NOTES", name: "Clinical notes" },
		{ id: "CLINIC_LETTER", name: "Clinic letter" },
		{ id: "REFERRAL", name: "Referral" },
		{ id: "AGREEMENT_TO_TREATMENT", name: "Agreement to treatment" },
		{ id: "CATQUEST", name: "Catquest" },
		{ id: "SCANNED_HISTORIC_NOTES", name: "Scanned historic notes" },
		{ id: "SCANNED_OPERATION_NOTE", name: "Scanned operation note" },
		{ id: "DISCHARGE_SUMMARY", name: "Discharge summary" },
		{ id: "OTHER", name: "Other" },
	],
	video: [{ id: "VIDEO", name: "Video" }],
});

app.constant("CALENDAR_SEEN",[
	{ name: "Arrived", value: "arrived" },
	{ name: "Technician start", value: "technician_started" },
	{ name: "Technician finish", value: "technician_finished" },
	{ name: "Nurse start", value: "nurse_started" },
	{ name: "Nurse finish", value: "nurse_finished" },
	{ name: "Optometrist start", value: "optometrist_started" },
	{ name: "Optometrist finish", value: "optometrist_finished" },
	{ name: "Orthoptist start", value: "orthoptist_started" },
	{ name: "Orthoptist finish", value: "orthoptist_finished" },
	{ name: "Doctor start", value: "doctor_started" },
	{ name: "Doctor finish", value: "doctor_finished" },
	{ name: "Departed", value: "departed" },
]);

app.constant("CALENDAR_CNA_DNA",[
	{ name: "Could not attend", value: "could_not_attend" },
	{ name: "Did not attend", value: "did_not_attend" },
	{ name: "Rebooked", value: "rebooked"},
]);


app.constant("OTHER_REFERRAL_DHB_LIST",[
	{value: "AUCKLAND", name: "HNZ Auckland"},
	{value: "BAY_OF_PLENTY", name: "HNZ Bay of Plenty"},
	{value: "CANTERBURY", name: "HNZ Canterbury"},
	{value: "CAPITAL_AND_COST", name: "HNZ Capital and Coast"},
	{value: "COUNTIES_MANUKAU", name: "HNZ Counties Manukau"},
	{value: "HAWKES_BAY", name: "HNZ Hawke's Bay"},
	{value: "HUTT_VALLEY", name: "HNZ Hutt Valley"},
	{value: "LAKES", name: "HNZ Lakes"},
	{value: "MID_CENTRAL", name: "HNZ MidCentral"},
	{value: "NELSON_MARLBOROUGH", name: "HNZ Nelson Marlborough"},
	{value: "NORTHLAND", name: "HNZ Northland"},
	{value: "SOUTH_CANTERBURY", name: "HNZ South Canterbury"},
	{value: "SOUTHERN", name: "HNZ Southern"},
	{value: "TAIRAWHITI", name: "HNZ Tairawhiti"},
	{value: "TARANAKI", name: "HNZ Taranaki"},
	{value: "WAIKATO", name: "HNZ Waikato"},
	{value: "WAIRARAPA", name: "HNZ Wairarapa"},
	{value: "WAITEMATA", name: "HNZ Waitemata"},
	{value: "WEST_COST", name: "HNZ West Coast"},
	{value: "WHANGANUI", name: "HNZ Whanganui"},
])

app.constant("REFERENCE_TYPE",[
	{value: "CASH", name: "Cash"},
	{value: "EFTPOS", name: "EFTPOS"},
	{value: "CREDIT_CARD", name: "Credit card"},
	{value: "INSURANCE", name: "Insurance"},
	{value: "INTERNET_BANKING", name: "Internet banking"},
	{value: "CHEQUE", name: "Cheque"},
	{value: "OTHER", name: "Other"},
])

app.constant("APPOINTMENT_TYPE",[
	{value: "CLINIC_APPOINTMENT", name: "Clinic Appointment"},
	{value: "CLINIC_PROCEDURE", name: "Clinic Procedure"},
	{value: "THEATRE_PROCEDURE", name: "Theatre Procedure"},
	{value: "UNKNOWN", name: "Unknown"},
])

// DICOM modality codes (0008,0060). Only the name is shown to users; the code is what the scanner sees.
app.constant("DICOM_MODALITIES",[
	{value: "OPT", name: "Corneal Tomography"},
	{value: "OCT", name: "OCT Scan"},
	{value: "OPV", name: "Visual Field"},
	{value: "AR", name: "Autorefraction"},
	{value: "FA", name: "Fluorescein angiography"},
	{value: "OP", name: "Fundus photography"},
	{value: "OT", name: "Other"},
])

app.constant('NHI_VERSION_V2',true);

app.constant("ANAESTHETIC_TYPE",[
	{value: "TOPICAL_SUBTENONS", name: "Topical Subtenons"},
	{value: "LOCAL", name: "Local"},
	{value: "LOCAL_SEDATION", name: "Local Sedation"},
	{value: "GENERAL", name: "General"},
]);

app.constant("SURGERY_AGREEMENT_TYPE",[
	{value: "CATARACT_SURGERY", name: "Cataract Surgery"},
	{value: "PPCEB", name: "PPCEB"},
	{value: "PENETRATING_KERATOPLASTY", name: "Penetrating Keratoplasty"},
	{value: "LAMELLAR_KERATOPLASTY", name: "Lamellar Keratoplasty"},
	{value: "DMEK_KERATOPLASTY", name: "Membrane Keratoplasty"},
	{value: "DSAEK_KERATOPLASTY", name: "Stripping Keratoplasty"},
	{value: "INTRACORNEAL_RING_SEGMENTS", name: "Intracorneal Ring Segments"},
	{value: "SUPERFICIAL_KERATECTOMY", name: "Superficial Keratectomy"},
	{value: "CORNEAL_CROSSLINKING", name: "Corneal Crosslinking"},
	{value: "TRABECULECTOMY", name: "Trabeculectomy"},
	{value: "INSERTION_GLAUCOMA_TUBE", name: "Insertion Glaucoma Tube"},
	{value: "INSERTION_MIGS", name: "Insertion Migs"},
	{value: "SCLERAL_FIXATED_LENS", name: "Scleral Fixated Lens"},
	{value: "IRIS_IMPLANT", name: "Iris Implant"},
	{value: "PIGGYBACK_LENS", name: "Piggyback Lens"},
	{value: "PHAKIC_LENS", name: "Phakic Lens"},
	{value: "INTRAVITREAL_INJECTION", name: "Intravitreal Injection"},
	{value: "VITRECTOMY", name: "Vitrectomy"},
	{value: "EPIRETINAL_MEMBRANE_PEEL", name: "Epiretinal Membrane Peel"},
	{value: "RETINAL_DETACHMENT_REPAIR", name: "Retinal Detachment Repair"},
	{value: "DELAMINATION", name: "Delamination"},
	{value: "YAG_LASER", name: "YAG Laser"},
	{value: "SLT", name: "SLT"},
	{value: "ALT", name: "ALT"},
	{value: "LASER_COAGULATION_RETINA", name: "Laser Coagulation Retina"},
	{value: "CYCLOABLATION", name: "Cycloablation"},
	{value: "BARRIER_LASER_RETINOPEXY", name: "Barrier Laser Retinopexy"},
	{value: "IRIDOTOMY", name: "Iridotomy"},
	{value: "LATERAL_TARSAL_STRIP", name: "Lateral Tarsal Strip"},
	{value: "ENUCLEATION", name: "Enucleation"},
	{value: "EVISCERATION", name: "Evisceration"},
	{value: "WEDGE_EXCISION_BIOPSY", name: "Wedge Excision Biopsy"},
	{value: "BLEPHAROPLASTY", name: "Blepharoplasty"},
	{value: "ENTROPION_REPAIR", name: "Entropion Repair"},
	{value: "INSERTION_DACRYOCYSTORHINOSTOMY_TUBE", name: "Insertion Dacryocystorhinostomy Tube"},
	{value: "DACRYOCYSTORHINOSTOMY", name: "Dacryocystorhinostomy"},
	{value: "CANTHOTOMY_CANTHOLYSIS", name: "Canthotomy Cantholysis"},
	{value: "REPAIR_CORNEAL_LACERATION", name: "Repair Corneal Laceration"},
	{value: "REPAIR_RUPTURED_GLOBE", name: "Repair Ruptured Globe"},
	{value: "REPAIR_LID_LACERATION", name: "Repair Lid Laceration"},
	{value: "REPAIR_LID_LACERATION_CANALICULAR_STENT", name: "Repair Lid Laceration Canalicular Stent"},
	{value: "REPAIR_ORBITAL_FRACTURE", name: "Repair Orbital Fracture"},
]);

// Audience a notification is sent to. `icon` is a Font Awesome 4 class.
app.constant("NOTIFICATION_TYPE", [
	{ value: "ALL_USERS", name: "Everyone", description: "Every CatTrax user", icon: "fa-globe" },
	{ value: "USER_IDS", name: "Specific users", description: "Pick individual people", icon: "fa-user" },
	{ value: "USER_ROLES", name: "User roles", description: "e.g. all optometrists", icon: "fa-id-badge" },
	{ value: "PRACTICE_IDS", name: "Specific practices", description: "Everyone at chosen practices", icon: "fa-hospital-o" },
	{ value: "PRACTICE_TYPES", name: "Practice types", description: "e.g. all public hospitals", icon: "fa-building-o" },
	{ value: "USER_ROLES_AND_PRACTICE_TYPES", name: "Roles within practice types", description: "e.g. nurses at public hospitals", icon: "fa-filter" },
])

// Ordered least to most severe. Colours live in _notifications.css (.notice-tone-<value>).
app.constant("NOTIFICATION_URGENCY_TYPE", [
	{ value: "STANDARD", name: "Standard", label: "Notice", description: "General news and updates", icon: "fa-info-circle" },
	{ value: "HIGH", name: "High", label: "Important", description: "Worth reading soon", icon: "fa-exclamation-circle" },
	{ value: "URGENT", name: "Urgent", label: "Action required", description: "Users need to act now", icon: "fa-exclamation-triangle" },
	{ value: "ERROR", name: "Error", label: "Service issue", description: "Outage or something broken", icon: "fa-times-circle" },
])

app.constant("NOTIFICATION_PATHWAY_TYPE", [
	{ value: "BANNER", name: "Banner", description: "Floats at the top of the screen and closes itself after a few seconds", icon: "fa-window-maximize" },
	{ value: "MODAL", name: "Pop-up", description: "Blocks the screen until the user clicks OK", icon: "fa-clone" },
])

app.constant("NOTIFICATION_VIEW_TYPE", [
	{ value: "ONCE", name: "Once per user", description: "Hidden for a user after they have seen it", icon: "fa-check" },
	{ value: "ALWAYS", name: "Every visit", description: "Shown on every dashboard visit until it ends", icon: "fa-repeat" },
])

// Quick-start notifications for the admin console. Choosing one fills in the create form; nothing
// is sent until the admin publishes it. Text in [SQUARE BRACKETS] is a placeholder the console
// refuses to publish until it has been replaced. `duration` is how long it runs, as moment.add() args.
app.constant("NOTIFICATION_TEMPLATES", [
	{
		id: "update",
		name: "CatTrax has updated",
		icon: "fa-rocket",
		title: "CatTrax has updated!",
		message: "<p>We've just released an update with improvements and fixes. Thanks for using CatTrax.</p>",
		notification_pathway_type: "BANNER",
		notification_urgency_type: "STANDARD",
		notification_view_type: "ONCE",
		duration: [3, "days"],
	},
	{
		id: "new_feature",
		name: "New feature",
		icon: "fa-star",
		title: "New in CatTrax: [FEATURE]",
		message: "<p>You can now [WHAT IT DOES]. Find it under [WHERE TO FIND IT].</p>",
		notification_pathway_type: "MODAL",
		notification_urgency_type: "STANDARD",
		notification_view_type: "ONCE",
		duration: [1, "week"],
	},
	{
		id: "maintenance",
		name: "Scheduled maintenance",
		icon: "fa-wrench",
		title: "Scheduled maintenance",
		message: "<p>CatTrax will be unavailable on <b>[DAY AND TIME]</b> for about <b>[DURATION]</b> while we carry out maintenance. Please save your work before then.</p>",
		notification_pathway_type: "MODAL",
		notification_urgency_type: "HIGH",
		notification_view_type: "ONCE",
		duration: [3, "days"],
	},
	{
		id: "disruption",
		name: "Service disruption",
		icon: "fa-exclamation-triangle",
		title: "We're having technical issues",
		message: "<p>Some parts of CatTrax may not be working as expected. Our team is on it and we'll update you as soon as it's fixed.</p>",
		notification_pathway_type: "BANNER",
		notification_urgency_type: "ERROR",
		notification_view_type: "ALWAYS",
		duration: [1, "day"],
	},
	{
		id: "resolved",
		name: "Issue resolved",
		icon: "fa-check-circle",
		title: "All systems working",
		message: "<p>The earlier issue has been fixed and CatTrax is working normally. Thanks for your patience.</p>",
		notification_pathway_type: "BANNER",
		notification_urgency_type: "STANDARD",
		notification_view_type: "ONCE",
		duration: [1, "day"],
	},
])

app.constant("CARETEAM_TYPE", [
	{value: "USER", name: "User"},
	{value: "PRACTICE", name: "Practice"},
	{value: "HPI_PRACTITIONER", name:"HPI Practitioner"},
	{value: "HPI_LOCATION", name:"HPI Location"},
	{value: "HPI_ORGANISATION", name:"HPI Organisation"},
	{value: "PRACTICE_DIRECTORY", name:"Practice Directory"}
])

app.constant("PROGRESS_NOTE_TYPE", [
	{ value: "PROGRESS_NOTE", name: "Default" },
	{ value: "VIRTUAL_CONSULT", name: "Virtual consult" },
	{ value: "ADMIN_NOTE", name: "Admin note" },
	{ value: "NURSE_NOTE", name: "Nurse note" },
])

// Every private health insurer Tyro can transact with over ECLIPSE, and the fund's ECLIPSE code, which is sent
// as healthFundCode on every verification, eligibility check and claim. A fund missing from this list cannot be
// claimed for at all, and a fund carrying the wrong code is claimed against whichever fund owns that code, so
// both are taken from Tyro's published list rather than written from the fund's name:
// https://help.tyrohealth.com/en/articles/6950085-health-funds-that-support-eclipse ("API/batch code" column).
//
// nib's Suncorp and Qantas Assure brands claim as nib under nib's own code, so they are not separate entries.
// Its AAMI and APIA brands are: Tyro publishes a code for each, and an AAMI or APIA membership claimed as nib
// is claimed against the wrong brand, so each is its own entry. CBHS Health and CBHS Corporate share the
// code "CBH" but are separate funds and are chosen separately, as the membership belongs to one of them.
//
// Support is per fund and per claim type: not every fund accepts every processing class, and only AHM, Bupa,
// GMHBA, HIF and Medibank accept overseas claims. That is a property of the claim rather than of the patient's
// record, so it is not modelled here - a claim made in a class its fund does not accept is declined by the fund.
app.constant("AUSTRALIAN_HEALTH_FUND_TYPE", [
	{ value: "AAMI", name: "AAMI Health Insurance", code: "AAMI" },
	{ value: "ACA_HEALTH_BENEFITS", name: "ACA Health Benefits Fund", code: "ACA" },
	{ value: "AHM", name: "AHM", code: "AHM" },
	{ value: "AIA_HEALTH", name: "AIA Health Insurance", code: "MYO" },
	{ value: "APIA", name: "APIA Health Insurance", code: "APIA" },
	{ value: "AUSTRALIAN_UNITY", name: "Australian Unity", code: "AUF" },
	{ value: "BUPA", name: "Bupa Australia", code: "BUP" },
	{ value: "CBHS_CORPORATE", name: "CBHS Corporate Health Fund", code: "CBH" },
	{ value: "CBHS_HEALTH", name: "CBHS Health Fund", code: "CBH" },
	{ value: "CDH_BENEFITS_FUND", name: "CDH Benefits Fund", code: "CDH" },
	{ value: "CUA_HEALTH", name: "CUA Health", code: "CPS" },
	{ value: "DEFENCE_HEALTH", name: "Defence Health", code: "AHB" },
	{ value: "DOCTORS_HEALTH", name: "Doctors' Health Fund", code: "AMA" },
	{ value: "GMHBA", name: "GMHBA", code: "GMH" },
	{ value: "GRAND_UNITED_CORPORATE_HEALTH", name: "Grand United Corporate Health", code: "GUH" },
	{ value: "HBF", name: "HBF", code: "HBF" },
	{ value: "HCF", name: "HCF", code: "HCF" },
	{ value: "HEALTH_CARE_INSURANCE", name: "Health Care Insurance", code: "HCI" },
	{ value: "HEALTH_INSURANCE_FUND_OF_AUSTRALIA", name: "Health Insurance Fund of Australia (HIF)", code: "HIF" },
	{ value: "HEALTH_PARTNERS", name: "Health Partners", code: "HPI" },
	{ value: "LATROBE", name: "Latrobe Health Services", code: "LHS" },
	{ value: "MEDIBANK", name: "Medibank Private", code: "MBP" },
	{ value: "MILDURA_HEALTH_FUND", name: "Mildura District Hospital Fund", code: "MDH" },
	{ value: "NATIONAL_HEALTH_BENEFITS_AUSTRALIA", name: "National Health Benefits Australia (onemedifund)", code: "OMF" },
	{ value: "NAVY_HEALTH", name: "Navy Health", code: "NHB" },
	{ value: "NIB", name: "NIB Health Fund (incl. Suncorp, Qantas Assure)", code: "NIB" },
	{ value: "NURSES_AND_MIDWIVES_HEALTH", name: "Nurses & Midwives Health", code: "NMW" },
	{ value: "PEOPLECARE", name: "Peoplecare Health", code: "LHM" },
	{ value: "PHOENIX_HEALTH_FUND", name: "Phoenix Health Fund", code: "PWA" },
	{ value: "POLICE_HEALTH", name: "Police Health", code: "PHF" },
	{ value: "QUEENSLAND_COUNTRY_HEALTH", name: "Queensland Country Health", code: "QCH" },
	{ value: "QUEENSLAND_TEACHERS_UNION_HEALTH", name: "Queensland Teachers' Union Health (TUH)", code: "QTU" },
	{ value: "RAILWAY_AND_TRANSPORT_HEALTH", name: "Railway and Transport Health (rt health)", code: "RTE" },
	{ value: "RESERVE_BANK_HEALTH_SOCIETY", name: "Reserve Bank Health Society", code: "RBH" },
	{ value: "ST_LUKES_HEALTH", name: "St Luke's Health", code: "STL" },
	{ value: "TEACHERS_HEALTH", name: "Teachers Federation Health", code: "TFH" },
	{ value: "TRANSPORT_HEALTH", name: "Transport Health", code: "TFS" },
	{ value: "WESTFUND", name: "Westfund", code: "WFD" },
]);

// Funds a patient record can still carry but that no claim can be made against: Tyro does not transact with
// them over ECLIPSE, so there is no code to claim under. Kept out of AUSTRALIAN_HEALTH_FUND_TYPE so they cannot
// be chosen for anyone, and kept here so a patient already recorded with one reads as that fund rather than as
// a blank while the practice moves them onto the policy they will actually be claimed on.
app.constant("AUSTRALIAN_HEALTH_FUND_TYPE_UNSUPPORTED", [
	{ value: "EMERGENCY_SERVICES_HEALTH", name: "Emergency Services Health", code: "" },
]);

// Not real funds. Tyro/Medipass only assess ECLIPSE requests in staging against the brand code "TST", so a
// patient has to be able to carry it to test in-patient claiming end to end. Kept out of
// AUSTRALIAN_HEALTH_FUND_TYPE so it can never reach production by being in the list everything reads:
// only callers that opt in via ENV.TEST_DATA_ENABLED offer it.
app.constant("AUSTRALIAN_HEALTH_FUND_TYPE_TEST", [
	{ value: "TEST_FUND", name: "Test Health Fund (staging only)", code: "TST" },
]);

app.constant("AU_HOSPITAL_COVER_TIER_TYPE", [
	{ value: "BASIC", name: "Basic" },
	{ value: "BASIC_PLUS", name: "Basic Plus" },
	{ value: "BRONZE", name: "Bronze" },
	{ value: "BRONZE_PLUS", name: "Bronze Plus" },
	{ value: "SILVER", name: "Silver" },
	{ value: "SILVER_PLUS", name: "Silver Plus" },
	{ value: "GOLD", name: "Gold" },
]);

// Which ECLIPSE channel a claim against the policy can use. An in-patient claim splits its settlement with
// Medicare, so it needs a Medicare entitlement that overseas visitor and student members do not have - their
// claims are settled entirely by the fund and go through the overseas channel instead. Patients covered by
// Medicare's Reciprocal Health Care Arrangement hold a Medicare card and claim as in-patients, so they are
// domestic as far as this choice goes.
app.constant("AU_OVERSEAS_COVER_TYPE", [
	{ value: "DOMESTIC", name: "Domestic cover" },
	{ value: "OVHC", name: "Overseas Visitor Health Cover (OVHC)" },
	{ value: "OSHC", name: "Overseas Student Health Cover (OSHC)" },
]);

// The presenting illness an eligibility check is quoted against, where it is given as an illness code rather
// than as the MBS item number of the principal procedure. Both series Medicare publishes are here: the 3xx
// codes and the 4xx codes cover much the same ground, and a fund may hold cover rules against either, so the
// code the fund's policy names is the code to send - neither series is a substitute for the other.
//
// Sent as presenting_illness_code, and only ever a code from this list: ECLIPSE rejects anything else, so the
// field is chosen rather than typed. Ordered by code, which is how the practice reads it off the policy.
app.constant("ECLIPSE_PRESENTING_ILLNESS_TYPE", [
	{ value: "301", name: "Minor Gynaecological Surgery" },
	{ value: "302", name: "Assisted Reproductive services or infertility treatments" },
	{ value: "303", name: "Pregnancy related services including Obstetrics" },
	{ value: "304", name: "Eye - Laser Surgery / refractive" },
	{ value: "305", name: "Eye - Cataracts" },
	{ value: "306", name: "Eye - Glaucoma" },
	{ value: "309", name: "Cardiac (heart and artery)" },
	{ value: "310", name: "Psychiatric" },
	{ value: "311", name: "Rehabilitation" },
	{ value: "313", name: "Surgical Podiatry" },
	{ value: "314", name: "Dialysis for chronic renal failure" },
	{ value: "315", name: "Chemotherapy" },
	{ value: "318", name: "Teeth/Dental" },
	{ value: "319", name: "Palliative care" },
	{ value: "320", name: "Medical admission" },
	{ value: "321", name: "Gastric Banding and all obesity related treatment" },
	{ value: "322", name: "Bone Marrow transfusion or transplant (autologous and allogeneic incl harvesting, cryopreservation)" },
	{ value: "323", name: "Spinal Fusion" },
	{ value: "324", name: "Back and spinal surgery excluding spinal fusion surgery" },
	{ value: "330", name: "Endoscopy including Colonoscopy and gastroscopy" },
	{ value: "331", name: "Cystoscopy" },
	{ value: "333", name: "Oesophagoscopy" },
	{ value: "334", name: "Shoulder arthroscopy and selected minor shoulder procedures" },
	{ value: "335", name: "Ankle arthroscopy and ankle ligament repair" },
	{ value: "336", name: "Knee arthroscopy and meniscectomy" },
	{ value: "341", name: "Joint replacement - Hip" },
	{ value: "342", name: "Joint replacement - Knee" },
	{ value: "343", name: "Joint replacement - Shoulder" },
	{ value: "344", name: "Joint replacement - Other" },
	{ value: "347", name: "Appendicitis" },
	{ value: "350", name: "Lithotripsy" },
	{ value: "351", name: "Insulin Pumps" },
	{ value: "360", name: "Sleep Studies" },
	{ value: "361", name: "Removal of Tonsils and Adenoids" },
	{ value: "370", name: "Plastic and reconstructive surgery" },
	{ value: "375", name: "Cosmetic" },
	{ value: "376", name: "Abdominoplasty" },
	{ value: "377", name: "Blepharoplasty" },
	{ value: "378", name: "Breast Augmentation/Reduction" },
	{ value: "379", name: "Labioplasty/vulvoplasty" },
	{ value: "380", name: "Lipectomy" },
	{ value: "381", name: "Liposuction" },
	{ value: "382", name: "Penile Enlargements" },
	{ value: "383", name: "Ptosis of skin" },
	{ value: "384", name: "Rhinoplasty" },
	{ value: "385", name: "Surgical face lifts" },
	{ value: "390", name: "Sterilisation" },
	{ value: "393", name: "Brain Surgery" },
	{ value: "394", name: "Vascular Surgery" },
	{ value: "395", name: "Organ Transplant" },
	{ value: "399", name: "Unknown or Other Surgery" },
	{ value: "400", name: "Miscarriage and termination of pregnancy" },
	{ value: "401", name: "Gynaecology" },
	{ value: "402", name: "Assisted reproductive services" },
	{ value: "403", name: "Pregnancy and birth" },
	{ value: "404", name: "Male reproductive system" },
	{ value: "405", name: "Cataracts" },
	{ value: "406", name: "Eye (not cataracts)" },
	{ value: "407", name: "Eye - Laser" },
	{ value: "408", name: "Lung and chest" },
	{ value: "409", name: "Heart and vascular system" },
	{ value: "410", name: "Hospital psychiatric services" },
	{ value: "411", name: "Rehabilitation" },
	{ value: "412", name: "Palliative care" },
	{ value: "413", name: "Kidney and bladder" },
	{ value: "414", name: "Dialysis for chronic kidney failure" },
	{ value: "415", name: "Chemotherapy, radiotherapy and immunotherapy for cancer" },
	{ value: "416", name: "Blood" },
	{ value: "417", name: "Bone marrow transfusion or transplant" },
	{ value: "418", name: "Dental surgery" },
	{ value: "419", name: "Podiatric surgery (provided by a registered podiatric surgeon)" },
	{ value: "420", name: "Medical admission (unknown)" },
	{ value: "423", name: "Back, neck and spine" },
	{ value: "424", name: "Bone, joint and muscle" },
	{ value: "425", name: "Joint reconstructions" },
	{ value: "426", name: "Joint replacements - other" },
	{ value: "427", name: "Joint replacements (hip and knee)" },
	{ value: "430", name: "Gastrointestinal endoscopy" },
	{ value: "431", name: "Hernia and appendix" },
	{ value: "432", name: "Digestive system" },
	{ value: "433", name: "Weight loss surgery" },
	{ value: "441", name: "Pain management" },
	{ value: "442", name: "Pain management with device" },
	{ value: "451", name: "Insulin pumps" },
	{ value: "452", name: "Diabetes management (excluding insulin pumps)" },
	{ value: "460", name: "Sleep studies" },
	{ value: "461", name: "Tonsils, adenoids and grommets" },
	{ value: "462", name: "Ear, nose and throat" },
	{ value: "463", name: "Implantation of hearing devices" },
	{ value: "470", name: "Plastic and reconstructive surgery (medically necessary)" },
	{ value: "471", name: "Skin" },
	{ value: "475", name: "Cosmetic surgery" },
	{ value: "478", name: "Breast surgery (medically necessary)" },
	{ value: "493", name: "Brain and nervous system" },
	{ value: "495", name: "Organ transplant" },
	{ value: "499", name: "Unknown or other surgery" },
]);

app.constant("AU_DVA_CARD_TYPE", [
	{ value: "GOLD", name: "Gold" },
	{ value: "WHITE", name: "White" },
	{ value: "ORANGE", name: "Orange" },
]);

app.constant("AU_INSURANCE_POLICY_STATUS_TYPE", [
	{ value: "ACTIVE", name: "Active" },
	{ value: "SUSPENDED", name: "Suspended" },
	{ value: "LAPSED", name: "Lapsed" },
	{ value: "INACTIVE", name: "Inactive" },
]);

app.constant("TIMEZONE_TYPE", [
	// --- New Zealand Timezones ---
	{ value: "PACIFIC_AUCKLAND", name: "Pacific/Auckland" },
	{ value: "PACIFIC_CHATHAM", name: "Pacific/Chatham" },

	// --- Australian Timezones ---
	{ value: "AUSTRALIA_SYDNEY", name: "Australia/Sydney" },
	{ value: "AUSTRALIA_MELBOURNE", name: "Australia/Melbourne" },
	{ value: "AUSTRALIA_HOBART", name: "Australia/Hobart" },
	{ value: "AUSTRALIA_BRISBANE", name: "Australia/Brisbane" },
	{ value: "AUSTRALIA_ADELAIDE", name: "Australia/Adelaide" },
	{ value: "AUSTRALIA_DARWIN", name: "Australia/Darwin" },
	{ value: "AUSTRALIA_PERTH", name: "Australia/Perth" }
]);

app.constant("EYE_BANK_TISSUE", [
	{ value: "PENETRATING_KERATOPLASTY", name: "Penetrating keratoplasty" },
	{ value: "DEEP_ANTERIOR_LAMELLAR_KERATOPLASTY", name: "Deep anterior lamellar keratoplasty" },
	{ value: "DSAEK_PRECUT", name: "DSAEK (precut)" },
	{ value: "DMEK", name: "DMEK" },
	{ value: "CAIRS", name: "CAIRS" },
	{ value: "AMNIOTIC_MEMBRANE", name: "Amniotic membrane" },
	{ value: "SCLERA", name: "sclera" },
]);

app.constant("OP_NOTE_EYE_BANK_FORM", [
	{ value: "42101009", name: "PK" },
	{ value: "722185000", name: "DMEK" },
	{ value: "722184001", name: "DSAEK" },
	{ value: "771988004", name: "DALK" },
]);

app.constant("PRIMARY_INDICATION_FOR_SURGERY_OPTICAL", [
	{ value: "KERATOCONUS", name: "Keratoconus" },
	{ value: "FUCHS_ENDOTHELIAL_DYSTROPHY", name: "Fuchs' Endothelial Dystrophy"},
	{ value: "PSEUDOPHAKIC_BULLOUS_KERATOPATHY", name: "Pseudophakic Bullous Keratopathy (PBK)"},
	{ value: "CORNEAL_SCAR_POST_INFECTIOUS", name: "Corneal Scar (Post-Infectious)" },
	{ value: "CORNEAL_SCAR_POST_TRAUMATIC", name: "Corneal Scar (Post-Traumatic)" },
	{ value: "STROMAL_DYSTROPHY", name: "Stromal Dystrophy (e.g., Lattice, Granular, Macular)" },
	{ value: "POST_REFRACTIVE_ECTASIA", name: "Post-Refractive Ectasia" },
]);

app.constant("PRIMARY_INDICATION_FOR_SURGERY_TECTONIC", [
	{ value: "CORNEAL_PERFORATION_LACERATION", name: "Corneal Perforation / Laceration (Acute Trauma)" },
	{ value: "CORNEAL_PERFORATION_NON_TRAUMATIC", name: "Corneal Perforation (Non-Traumatic)"},
	{ value: "DESCEMETOCELE", name: "Descemetocele"},
	{ value: "CORNEAL_MELT_STERILE", name: "Corneal Melt (Sterile)" },
]);

app.constant("PRIMARY_INDICATION_FOR_SURGERY_THERAPEUTIC", [
	{ value: "INFECTIOUS_KERATITIS", name: "Infectious Keratitis (e.g., Fungal, Acanthamoeba, resistant Bacterial)" },
	{ value: "ACTIVE_CORNEAL_ULCER", name: "Active Corneal Ulcer (non-resolving)"},
]);

app.constant("PRIMARY_INDICATION_FOR_SURGERY_GRAFT", [
	{ value: "GRAFT_FAILURE_PRIMARY", name: "Graft Failure (Primary)" },
	{ value: "GRAFT_REJECTION_IRREVERSIBLE", name: "Graft Rejection (Irreversible)"},
	{ value: "LATE_ENDOTHELIAL_FAILURE", name: "Late Endothelial Failure (Idiopathic)"},
]);

app.constant("PRIMARY_INDICATION_FOR_SURGERY_OTHER", [
	{ value: "CONGENITAL_OPACITY", name: "Congenital Opacity (e.g., Peter's Anomaly)" },
	{ value: "CHEMICAL_THERMAL_INJURY_SEQUELAE", name: "Chemical/Thermal Injury Sequelae"},
	{ value: "OTHER", name: "Other (specify)"},
]);

app.constant("NOK_RELATIONSHIP_TYPES", [
	'Spouse', 
	'Child', 
	'Parent', 
	'Sibling', 
	'Friend', 
	'Other'
])

app.constant('CALENDAR_AVAILABILITY_991',true);
app.constant('REFERRALS_PATHWAY_1028',true);

app.constant('PREMIUM_LENS_RECOMMENDATION_1036',true);
app.constant('HPI_PHARMACY_SEARCH', false); // This should be false until NZePS is implemented.
app.constant('PREMIUM_USER_STRIPE_FEATURE_1040', true);
app.constant('NOTIFICATIONS_UPGRADE_1067', true);

app.constant('IDLE_TIMER_1071', true);
app.constant('SURGERY_WAITLIST_1049', true)
app.constant('CLINIC_LETTER_282', true);
app.constant('ELEVEN_LABS_AI_ALCON_AGENT_1090', false);
app.constant('UPLOAD_SIGNATURE_IMAGE_1096', true);
app.constant('CALENDAR_ENHANCEMENT_976', true);
app.constant('ELEVEN_LABS_AI_1097', true);
app.constant("NEXT_OF_KIN_1070", true);
app.constant("ELEVEN_LABS_AI_TOUR_1261", true);

app.constant("CALENDAR_PERSONAL_TEMPLATE_1257", true);

app.constant("OPNOTE_SAVE_OTHER_PROCEDURE_1296", true);
app.constant("EORDERS_1054", true);

// The labs POST /api/e-orders/{patientId} accepts, sent as the body. Must match EOrdersProvider in CatTraxCore.
app.constant("EORDER_PROVIDERS", {
	MEDLAB: "MEDLAB",
	PATHLAB: "PATHLAB",
	AWANUI: "AWANUI",
});

app.constant("PATIENT_FORM_1258", true);



	

// The colour each practice is marked with, on the calendar, the task list and the surgery waitlist. Handed out
// in order of practice id, so a practice is the same colour on each.
app.constant("PRACTICE_PALETTE", ["#2a307f", "#00897b", "#c2410c", "#7b1fa2", "#2e7d32", "#1565c0", "#ad1457", "#5d4037"]);

// The components a custom form template can be built from, in the order the builder's palette offers them.
// `kind` is the builder's own tag; the API tells the types apart by their fields, not by a type property.
app.constant("CUSTOM_FORM_COMPONENT_TYPES", [
	{ kind: "question", label: "Question", icon: "fa-question-circle", description: "Ask the patient something" },
	{ kind: "header", label: "Header", icon: "fa-header", description: "Start a new section" },
	{ kind: "image", label: "Image", icon: "fa-picture-o", description: "Show a picture" },
]);
